import React, { FC } from 'react'

import { ProgressBar } from '../ProgressBar/ProgressBar'

import { ByIdMap, Nutritions, nutritionsConfig } from 'Models'
import { Calculator } from 'Utils'

const titles: ByIdMap<string> = {
  carbohydrates: 'Kohlenhydrate',
  protein: 'Protein',
  fat: 'Fett'
}

type Props = {
  acceptedNutritions: Nutritions
  goalNutritions: Nutritions
  isLoading: boolean
}

export const MacronutrientProgressBars: FC<Props> = ({ acceptedNutritions, goalNutritions, isLoading }) => {
  const percentages = Calculator.calculateNutritionPercentage(acceptedNutritions, goalNutritions)

  return (
    <>
      {(Object.keys(titles) as Array<keyof typeof titles>).map((key) => {
        const percentage = (percentages[key as keyof Nutritions] || 0) * 100

        const progressText = `${Math.round(acceptedNutritions[key as keyof Nutritions] || 0)} / ${Math.round(
          goalNutritions[key as keyof Nutritions] || 0
        )} g`

        return (
          <div key={key}>
            <ProgressBar
              title={titles[key]}
              progressAsPercentage={percentage}
              progressText={isLoading ? '' : progressText}
              barColor={nutritionsConfig[key].color}
            />
          </div>
        )
      })}
    </>
  )
}
